import React from "react";
import { ReactNode } from "react";
export interface SlidePicturePropItem {
    src: string;
    alt: string;
    icon: string;
    link?: string;

}
export interface SlidePictureProps {
    item: SlidePicturePropItem[],
    interval?: number;
}


export class SlidePicture extends React.Component<SlidePictureProps>{
    state = { current: (this.props.item!.length > 0 ? this.props.item[0] : null) as null | SlidePicturePropItem, curIndex: 0 as number };
    static timer: number = 0;
    componentDidMount(): void {
        clearInterval(SlidePicture.timer);
        this.setState({ current: this.props.item[0], curIndex: 0 });
        if (this.props.interval != null) {

            SlidePicture.timer = window.setInterval(() => {
                this.switchImg((this.state.curIndex + 1) % this.props.item.length);
            }, this.props.interval * 1000);
        }
    }
    public switchImg(idx: number) {

        this.setState({ current: this.props.item[idx], curIndex: idx });
        if (this.props.children != null) {
            document.querySelectorAll(".icon>img").forEach((item) => { item.classList?.remove("choice") });
            document.querySelectorAll(".icon>img")[idx]?.classList?.add("choice");
        }
    }
    render(): ReactNode {

        let imgcontainer = <></>;
        if (this.state?.current?.link == null || this.state.current.link === "") {

            imgcontainer = <img src={this.state.current!.src} alt={this.state.current!.alt}></img>
        } else {

            imgcontainer = <a href={this.state.current!.link}><img src={this.state.current!.src} alt={this.state.current!.alt}></img></a>
        }


        let r =
            <>
                <div className="banner">
                    {imgcontainer}
                </div>

                {this.props.children}

            </>
        return r;
    }
}